<div *ngIf="aberto" class="fixed inset-0 z-[350] flex items-center justify-center p-4 tema-claro"
     [style.display]="pausado ? 'none' : null" [attr.aria-hidden]="pausado || null"
     style="background-color: rgba(36,41,45,0.45)">
  <div class="hp-modal" (click)="$event.stopPropagation()" role="dialog" aria-label="Histórico do Paciente">

    <!-- Cabeçalho fixo -->
    <div class="hp-fixo">
      <div class="hp-linha-marca"></div>
      <div class="hp-header">
        <h2 class="hp-titulo">Histórico do Paciente</h2>
        <button type="button" class="hp-icone" title="Fechar" (click)="fechar.emit()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Paciente: busca ou cartão -->
      <div class="hp-paciente-area">
        <div *ngIf="!paciente" class="hp-busca-wrap">
          <div class="hp-busca">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
            </svg>
            <input [(ngModel)]="busca" (ngModelChange)="onBusca()" placeholder="Buscar por nome, CPF, código ou nº do atendimento" aria-label="Buscar paciente" autofocus />
          </div>
          <div *ngIf="buscando || resultados.length || busca.trim().length >= 3" class="hp-resultados">
            <p *ngIf="buscando" class="hp-vazio-mini">Buscando...</p>
            <button *ngFor="let r of resultados" type="button" class="hp-resultado" (click)="escolher(r)">
              <span class="min-w-0">
                <span class="hp-res-nome">{{ r.nmPessoaFisica | titlecase }}</span>
                <span *ngIf="r.nrAtendimento" class="hp-res-det hp-res-atend">Atendimento {{ r.nrAtendimento }} · {{ diaMesAno(r.dtEntrada) }}</span>
                <span class="hp-res-det">{{ r.nrCpf ? 'CPF ' + formatarCpf(r.nrCpf) : 'Sem CPF' }} · Cód. {{ r.cdPessoaFisica }}</span>
              </span>
            </button>
            <p *ngIf="!buscando && !resultados.length && busca.trim().length >= 3" class="hp-vazio-mini">Nenhum paciente encontrado.</p>
          </div>
        </div>

        <div *ngIf="paciente" class="hp-cartao">
          <div class="hp-linha-nome">
            <span class="hp-cartao-nome">{{ paciente.nome | titlecase }}</span>
            <span class="hp-cod">Cód. {{ paciente.cdPessoaFisica }}</span>
            <span *ngIf="etiquetaPlano as ep" class="hp-plano" [class.particular]="ep.particular" title="Plano que o paciente tem hoje">{{ ep.texto }}</span>
          </div>
          <div class="hp-acoes-cartao">
            <a [href]="linkAdmin" target="_blank" rel="noopener">Ver no admin</a>
            <button type="button" (click)="limparPaciente()">Trocar paciente</button>
          </div>
          <div class="hp-dados">
            <div><span class="hp-rotulo">CPF</span><span class="hp-valor">{{ dadosCartao.cpf }}</span></div>
            <div><span class="hp-rotulo">Nascimento</span><span class="hp-valor">{{ dadosCartao.nascimento }}</span></div>
            <div><span class="hp-rotulo">Sexo</span><span class="hp-valor">{{ dadosCartao.sexo }}</span></div>
            <div><span class="hp-rotulo">Telefone</span><span class="hp-valor">{{ dadosCartao.telefone }}</span></div>
            <div><span class="hp-rotulo">CEP</span><span class="hp-valor">{{ dadosCartao.cep }}</span></div>
            <div class="hp-largo"><span class="hp-rotulo">E-mail</span><span class="hp-valor">{{ dadosCartao.email }}</span></div>
            <div class="hp-largo"><span class="hp-rotulo">Endereço</span><span class="hp-valor">{{ dadosCartao.endereco }}</span></div>
          </div>
        </div>
      </div>

      <!-- Seções -->
      <div *ngIf="paciente" class="hp-secoes" role="tablist">
        <button *ngFor="let s of SECOES" type="button" role="tab" [class.ativa]="aba === s.id" [attr.aria-selected]="aba === s.id"
                (click)="trocarAba(s.id)">
          {{ s.rotulo }}
          <span *ngIf="contador(s.id) as n" class="hp-badge">{{ n }}</span>
          <span *ngIf="s.id === 'adiantamentos' && carregada.adiantamentos && saldoDisponivel > 0" class="hp-badge-saldo">{{ saldoDisponivel | brl }}</span>
        </button>
        <span class="hp-barra-dir">
          <button type="button" class="hp-icone" title="Atualizar" [disabled]="carregando[aba]" (click)="atualizar()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
          </button>
        </span>
      </div>

      <!-- Filtros da seção (só na tela) -->
      <div *ngIf="paciente && aba === 'contas' && carregada.contas" class="hp-filtros">
        <button *ngFor="let f of FILTROS_CONTA" type="button" class="hp-chip" [class.ativo]="filtroContas === f.id"
                [attr.aria-pressed]="filtroContas === f.id" (click)="filtroContas = f.id">
          {{ f.rotulo }} · {{ contarContas(f.id) }}
        </button>
      </div>
      <div *ngIf="paciente && aba === 'agendamentos'" class="hp-filtros">
        <select class="hp-campo" [(ngModel)]="filtroTipo" aria-label="Tipo">
          <option value="">Todos os tipos</option>
          <option value="CONSULTA">Consulta</option>
          <option value="EXAME">Exame</option>
        </select>
        <select class="hp-campo" [(ngModel)]="filtroStatus" aria-label="Status">
          <option value="">Todos os status</option>
          <option *ngFor="let s of STATUS_FILTRO" [value]="s[0]">{{ s[1] }}</option>
        </select>
      </div>
    </div>

    <!-- Corpo -->
    <div class="hp-corpo">
      <p *ngIf="!paciente" class="hp-vazio">Busque um paciente para ver orçamentos, contas, atendimentos, adiantamentos, notas fiscais, agendamentos e cupons.</p>

      <ng-container *ngIf="paciente">
        <!-- Contas fica montada durante a recarga: o destaque e os itens abertos não se perdem. -->
        <p *ngIf="carregando[aba] && !(aba === 'contas' && carregada.contas)" class="hp-vazio">Carregando...</p>
        <p *ngIf="erro[aba]" class="hp-vazio hp-erro">{{ erro[aba] }}</p>

        <!-- Orçamentos -->
        <div *ngIf="aba === 'orcamentos' && carregada.orcamentos && !carregando.orcamentos" class="hp-secao">
          <app-hp-orcamentos [orcamentos]="orcamentos"></app-hp-orcamentos>
        </div>

        <!-- Contas -->
        <div *ngIf="aba === 'contas' && carregada.contas" class="hp-secao">
          <app-hp-contas [contas]="contas" [supervisor]="supervisorConta" [destacar]="destacarConta" [aviso]="avisoContas"
                         [filtro]="filtroContas" (filtroChange)="filtroContas = $event"
                         (pagar)="onPagar($event)" (vincular)="onVincular($event)" (menu)="onMenu($event)"></app-hp-contas>
        </div>

        <!-- Notas fiscais -->
        <div *ngIf="aba === 'notas' && carregada.notas && !carregando.notas" class="hp-secao">
          <app-hp-notas [notas]="notasFiscais"></app-hp-notas>
        </div>

        <!-- Agendamentos -->
        <ng-container *ngIf="aba === 'agendamentos' && !carregando.agendamentos && !erro.agendamentos">
          <p *ngIf="!agendamentosFiltrados.length" class="hp-vazio">Nenhum agendamento.</p>
          <ng-container *ngFor="let g of gruposAgendamentos">
            <div class="hp-mes">{{ g.titulo }} <span>{{ g.itens.length }}</span></div>
            <div *ngFor="let a of g.itens" class="hp-linha">
              <div class="hp-data">
                <b>{{ diaMes(a.dtAgenda) }}</b><span>{{ diaSemana(a.dtAgenda) }} · {{ a.hrInicio }}</span>
              </div>
              <div class="hp-info">
                <div class="hp-info-titulo">
                  <span class="hp-titulo-texto">{{ a.dsExame || a.dsEspecialidade || '—' }}</span>
                  <span class="hp-selo" [ngClass]="a.tipo === 'EXAME' ? 'tipo-exame' : 'tipo-consulta'">{{ a.tipo === 'EXAME' ? 'Exame' : 'Consulta' }}</span>
                  <span *ngIf="a.dsClassif && a.dsClassif !== 'Exames'" class="hp-selo" [ngClass]="'tipo-' + corTipo(a)">{{ a.dsClassif }}</span>
                </div>
                <div class="hp-meta">
                  <span *ngIf="a.dsExame && a.dsEspecialidade">{{ a.dsEspecialidade }}</span>
                  <span *ngIf="a.nmMedico">{{ a.nmMedico }}</span>
                  <span *ngIf="!a.nmMedico && a.dsAgenda">{{ a.dsAgenda }}</span>
                  <span>{{ a.nmEstabelecimento }}</span>
                  <span *ngIf="a.dsConvenio">{{ a.dsConvenio }}</span>
                  <span *ngIf="a.nmUsuarioAgendou" class="hp-meta-leve">agendado por {{ a.nmUsuarioAgendou }}</span>
                </div>
              </div>
              <div class="hp-lado">
                <span class="hp-selo" [ngClass]="'st-' + corStatus(a.ieStatusAgenda)">{{ a.dsStatusAgenda }}</span>
                <span *ngIf="a.nrAtendimento" class="hp-meta-leve">Atend. {{ a.nrAtendimento }}</span>
              </div>
              <div class="hp-acoes">
                <ng-container *ngIf="a.nrAtendimento">
                  <button type="button" class="hp-acao" title="Notas fiscais" (click)="abrirNotas(a.nrAtendimento)">NF</button>
                  <button type="button" class="hp-acao" title="Ficha de atendimento" (click)="ficha(a.nrAtendimento)">Ficha</button>
                </ng-container>
              </div>
            </div>
          </ng-container>
          <div *ngIf="qtAgendamentosOcultos > 0" class="hp-mais">
            <button type="button" class="hp-chip" (click)="mostrarTodosAgendamentos = true">Ver mais ({{ qtAgendamentosOcultos }})</button>
          </div>
        </ng-container>

        <!-- Atendimentos -->
        <ng-container *ngIf="aba === 'atendimentos' && !carregando.atendimentos && !erro.atendimentos">
          <p *ngIf="avisoAtendimento" class="hp-aviso">{{ avisoAtendimento }}</p>
          <p *ngIf="!atendimentos.length" class="hp-vazio">Nenhum atendimento.</p>
          <ng-container *ngFor="let g of gruposAtendimentos">
            <div class="hp-mes">{{ g.titulo }} <span>{{ g.itens.length }}</span></div>
            <div *ngFor="let a of g.itens" class="hp-linha" [attr.data-atendimento]="a.nrAtendimento"
                 [class.hp-linha-buscada]="a.nrAtendimento === atendimentoBuscado">
              <div class="hp-data">
                <b>{{ diaMes(a.dtEntrada) }}</b><span>{{ diaSemana(a.dtEntrada) }} · {{ a.hrEntrada }}</span>
              </div>
              <div class="hp-info">
                <div class="hp-info-titulo">
                  <span class="hp-titulo-texto">Atendimento {{ a.nrAtendimento }}</span>
                  <span *ngIf="a.avulso" class="hp-selo tipo-proc" title="Atendimento aberto sem agendamento">Avulso</span>
                  <span *ngIf="!a.avulso" class="hp-meta-leve">{{ vinculo(a) }}</span>
                </div>
                <div class="hp-meta">
                  <span *ngIf="a.nmMedico">{{ a.nmMedico }}</span>
                  <span>{{ a.nmEstabelecimento }}</span>
                  <span *ngIf="a.dsConvenio">{{ a.dsConvenio }}</span>
                  <span *ngIf="a.dsTipoAtendimento" class="hp-meta-leve">{{ a.dsTipoAtendimento }}</span>
                </div>
              </div>
              <div class="hp-lado">
                <span class="hp-selo" [ngClass]="'conta-' + (a.ieSituacaoConta | lowercase)" [title]="a.dsSituacaoDetalhe">{{ a.dsSituacaoConta }}</span>
                <span class="hp-meta-leve" [title]="a.dsSituacaoDetalhe">{{ a.ieSituacaoConta === 'PROVISORIO' ? 'falta fechar a conta' : '' }}</span>
              </div>
              <div class="hp-acoes">
                <button *ngIf="temConta(a)" type="button" class="hp-acao hp-acao-forte" title="Ver a conta na seção Contas" (click)="verConta(a.nrAtendimento)">Conta</button>
                <button type="button" class="hp-acao" title="Notas fiscais" (click)="abrirNotas(a.nrAtendimento)">NF</button>
                <button type="button" class="hp-acao" title="Ficha de atendimento" (click)="ficha(a.nrAtendimento)">Ficha</button>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Adiantamentos -->
        <ng-container *ngIf="aba === 'adiantamentos' && !carregando.adiantamentos && !erro.adiantamentos">
          <p *ngIf="erroReimpressao" class="hp-aviso">{{ erroReimpressao }}</p>
          <p *ngIf="!adiantamentos.length" class="hp-vazio">Nenhum adiantamento.</p>
          <div *ngIf="adiantamentos.length" class="hp-totais">
            <div><span>Adiantado</span><b>{{ totalAdiantado | brl }}</b></div>
            <div><span>Saldo disponível</span><b [class.hp-positivo]="saldoDisponivel > 0">{{ saldoDisponivel | brl }}</b></div>
            <small>Saldo sem estornados e transferidos · últimos 20 adiantamentos</small>
          </div>
          <ng-container *ngFor="let g of gruposAdiantamentos">
            <div class="hp-mes">{{ g.titulo }} <span>{{ g.itens.length }}</span></div>
            <div *ngFor="let a of g.itens" class="hp-linha">
              <div class="hp-data">
                <b>{{ a.dtAdiantamento | date: 'dd/MM' }}</b><span>{{ diaSemana(a.dtAdiantamento) }} · {{ a.dtAdiantamento | date: 'HH:mm' }}</span>
              </div>
              <div class="hp-info">
                <div class="hp-info-titulo">
                  <span class="hp-titulo-texto">Adiantamento {{ a.nrAdiantamento }}</span>
                  <span *ngIf="a.nrDocumento" class="hp-meta-leve">Ref. {{ a.nrDocumento }}</span>
                </div>
                <div class="hp-meta">
                  <span>{{ nomeUnidade(a.cdEstabelecimento) }}</span>
                  <span *ngIf="a.dsObservacao" class="hp-meta-obs" [title]="a.dsObservacao">{{ a.dsObservacao }}</span>
                </div>
              </div>
              <div class="hp-lado hp-valores">
                <b>{{ a.vlAdiantamento | brl }}</b>
                <span [class.hp-positivo]="saldo(a) > 0">saldo {{ saldo(a) | brl }}</span>
              </div>
              <div class="hp-acoes">
                <span class="hp-selo" [ngClass]="'st-' + situacao(a).classe">{{ situacao(a).texto }}</span>
                <button type="button" class="hp-acao" [disabled]="reimprimindo === a.nrAdiantamento" (click)="reimprimir(a)">
                  {{ reimprimindo === a.nrAdiantamento ? 'Gerando...' : 'Reimprimir' }}
                </button>
              </div>
            </div>
          </ng-container>
          <div *ngIf="qtAdiantamentosAnteriores > 0" class="hp-mais">
            <button type="button" class="hp-chip" (click)="mostrarTodosAdiantamentos = true">Ver mais — {{ qtAdiantamentosAnteriores }} adiantamentos anteriores</button>
          </div>
          <div *ngIf="adiantamentos.length" class="hp-resumo-saldo">
            <span>Saldo disponível</span>
            <span><b>{{ saldoDisponivel | brl }}</b> · {{ qtComSaldo }} adiantamento(s) com saldo</span>
          </div>
        </ng-container>

        <!-- Cupons -->
        <ng-container *ngIf="aba === 'cupons' && !carregando.cupons && !erro.cupons">
          <div *ngIf="!cupons.length" class="hp-vazio">
            Nenhum cupom disponível para este paciente.
            <span class="block text-xs mt-1">Cupom já usado, cancelado ou vencido não aparece aqui.</span>
          </div>

          <ng-container *ngIf="cupons.length">
            <div class="hp-totais">
              <div><span>Cupons disponíveis</span><b>{{ qtCupons }}</b></div>
              <div *ngIf="qtCuponsVencendo"><span>Vencem em até 7 dias</span><b class="hp-alerta">{{ qtCuponsVencendo }}</b></div>
              <div class="hp-tipos">
                <span *ngFor="let t of resumoTipos" class="hp-tipo-chip" [ngClass]="'cupom-' + (t.tipo || 'x')">{{ t.rotulo }} · {{ t.qt }}</span>
              </div>
              <small>O cupom é aplicado na tela de pagamento da conta.</small>
            </div>

            <div class="hp-cupons">
              <div *ngFor="let c of cuponsOrdenados" class="hp-ticket" [ngClass]="'cupom-' + (c.tipo || 'x')"
                   [class.hp-ticket-urgente]="diasParaVencer(c) !== null && diasParaVencer(c)! <= 7">
                <div class="hp-ticket-valor">
                  <span class="hp-ticket-rotulo">{{ valorTicket(c).rotulo }}</span>
                  <b>{{ valorTicket(c).valor }}</b>
                  <span *ngIf="c.quantidade > 1" class="hp-ticket-qt">{{ c.quantidade }} cupons</span>
                </div>
                <div class="hp-ticket-corpo">
                  <div class="hp-ticket-codigo"><span [title]="c.codigo">{{ c.codigo || 'Cupom sem código' }}</span></div>
                  <div *ngIf="c.descricao" class="hp-ticket-desc" [title]="c.descricao">{{ c.descricao }}</div>
                  <div class="hp-ticket-validade">
                    <span class="hp-selo" [ngClass]="'cupom-selo-' + (c.tipo || 'x')">{{ rotuloTipo(c.tipo) }}</span>
                    <span class="hp-ticket-prazo" [class.hp-alerta]="diasParaVencer(c) !== null && diasParaVencer(c)! <= 7"
                          [title]="c.dtExpiracao ? 'Válido até ' + c.dtExpiracao : ''">
                      {{ textoValidade(c) }}<ng-container *ngIf="c.dtExpiracao"> · {{ c.dtExpiracao }}</ng-container>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <div class="hp-rodape">
      <span *ngIf="paciente && aba === 'agendamentos' && agendamentos.length">{{ agendamentosFiltrados.length }} de {{ agendamentos.length }} agendamento(s)</span>
      <span *ngIf="paciente && aba === 'atendimentos' && atendimentos.length">{{ atendimentos.length }} atendimento(s) · {{ qtAvulsos }} sem agendamento</span>
      <button type="button" class="hp-botao-sec" (click)="fechar.emit()">Fechar</button>
    </div>
  </div>

  <!-- Notas fiscais do atendimento -->
  <div *ngIf="notasDoAtendimento" class="hp-sobre" (click)="$event.stopPropagation(); notasDoAtendimento = null">
    <div class="hp-notas" (click)="$event.stopPropagation()" role="dialog" aria-label="Notas fiscais">
      <div class="hp-header">
        <h3 class="hp-titulo" style="font-size: 16px">Notas fiscais · Atendimento {{ notasDoAtendimento }}</h3>
        <button type="button" class="hp-icone" title="Fechar" (click)="notasDoAtendimento = null">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="hp-notas-corpo">
        <p *ngIf="carregandoNotas" class="hp-vazio">Carregando...</p>
        <p *ngIf="erroNotas" class="hp-vazio hp-erro">{{ erroNotas }}</p>
        <p *ngIf="!carregandoNotas && !erroNotas && !notas.length" class="hp-vazio">Nenhuma nota fiscal emitida para este atendimento.</p>
        <div *ngFor="let n of notas" class="hp-nota">
          <div class="min-w-0">
            <div class="hp-cupom-nome">{{ n.nrNf ? 'NF ' + n.nrNf : 'RPS ' + n.nrRps + ' (aguardando NF)' }}</div>
            <div class="hp-sub">Emitida em {{ n.dtEmissao }}<ng-container *ngIf="n.nrNf"> · RPS {{ n.nrRps }}</ng-container></div>
            <div *ngIf="n.nmEmitidaPara" class="hp-aviso-mini">
              Emitida em nome de {{ n.nmEmitidaPara | titlecase }}<ng-container *ngIf="n.cpfEmitidaPara"> (CPF {{ formatarCpf(n.cpfEmitidaPara) }})</ng-container> — responsável
            </div>
          </div>
          <div class="text-right">
            <div class="hp-cupom-valor">{{ n.vlTotalNota | brl }}</div>
            <a class="hp-acao" [href]="n.urlNfs" target="_blank" rel="noopener">{{ n.nrNf ? 'Consultar' : 'Validar' }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
